// _textAnimations.js

import { getGSAP } from './_gsap.js';

export function initSmoothLettersAnimation() {
  const gsap = getGSAP();
  
  // Sélectionnez tous les éléments avec l'attribut data-animation="smooth-letters"
  const elements = document.querySelectorAll('[data-animation="smooth-letters"]');
  
  elements.forEach(element => {
    // Divisez le texte en mots, puis en lettres
    const words = element.textContent.split(/\s+/);
    element.innerHTML = '';
    
    const letters = words.map((word, wordIndex) => {
      const wordSpan = document.createElement('span');
      wordSpan.style.display = 'inline-block';
      wordSpan.style.whiteSpace = 'nowrap';
      
      const letterSpans = word.split('').map(letter => {
        const span = document.createElement('span');
        span.textContent = letter;
        span.style.display = 'inline-block';
        wordSpan.appendChild(span);
        return span;
      });
      
      element.appendChild(wordSpan);
      if (wordIndex < words.length - 1) {
        element.appendChild(document.createTextNode(' ')); // Ajouter un espace entre les mots
      }
      
      return letterSpans;
    }).flat(); // Aplatir le tableau de tableaux en un seul tableau de lettres
    
    // Créez l'animation
    gsap.from(letters, {
      opacity: 0,
      y: '0.33em',
      duration: 0.5,
      stagger: 0.02, // Réduit légèrement pour compenser le nombre accru d'éléments
      ease: 'power3.out',
      scrollTrigger: {
        trigger: element,
        start: 'top 80%',
        toggleActions: 'play none none none'
      }
    });
  });
}